import { useEffect } from "react";

const upsertMeta = (name, content, attr = "name") => {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  let created = false;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
    created = true;
  }
  const prev = el.getAttribute("content");
  el.setAttribute("content", content);
  return { el, prev, created };
};

export const Seo = ({ title, description, canonical, jsonLd }) => {
  const jsonKey = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (title) {
      window.__seoTitle = title;
      document.title = title;
    }
    const desc = upsertMeta("description", description);
    const ogTitle = upsertMeta("og:title", title, "property");
    const ogDesc = upsertMeta("og:description", description, "property");

    let canonEl = null, canonPrev = null, canonCreated = false;
    if (canonical) {
      canonEl = document.head.querySelector('link[rel="canonical"]');
      if (!canonEl) {
        canonEl = document.createElement("link");
        canonEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonEl);
        canonCreated = true;
      }
      canonPrev = canonEl.getAttribute("href");
      canonEl.setAttribute("href", canonical);
    }

    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      window.__seoTitle = null;
      const restore = (ref) => {
        if (!ref) return;
        if (ref.created) ref.el.remove();
        else if (ref.prev != null) ref.el.setAttribute("content", ref.prev);
      };
      restore(desc);
      restore(ogTitle);
      restore(ogDesc);
      if (canonEl) {
        if (canonCreated) canonEl.remove();
        else if (canonPrev != null) canonEl.setAttribute("href", canonPrev);
      }
      if (script) script.remove();
    };
  }, [title, description, canonical, jsonKey]);

  return null;
};
